import { IntegrationAlert } from "./IntegrationAlert";

type CompanyCamStatusBannerProps = {
  error: string | null;
  onDismiss?: () => void;
  visible?: boolean;
};

export const CompanyCamStatusBanner = ({
  error,
  onDismiss,
  visible = true,
}: CompanyCamStatusBannerProps) => {
  if (!visible || !error) {
    return null;
  }

  return (
    <div className="px-4 pt-4">
      <IntegrationAlert
        variant="error"
        provider="company_cam"
        title="CompanyCam sync failed"
        message={error}
        showSettingsLink
        onDismiss={onDismiss}
      />
    </div>
  );
};
